<template>
  <div id="app" ref="app">
    <tab></tab>  
    <!-- <wecode></wecode> -->
    <keep-alive>
    	<router-view></router-view>
    </keep-alive>
    <footer-box></footer-box>
  </div>
</template>

<script type="text/ecmascript-6">
	import Tab from './base/tab/tab'
	import FooterBox from './base/footer/footer'
	import {mapMutations} from 'vuex'
	// import Wecode from './base/wecode/wecode'

	export default{
		created() {
			this.changeView()
			this.recalc()
		},
		computed:{
		},
		methods:{
			changeView() {
				const docEl=document.documentElement;
				const resizeEvt="orientationchange" in window ? "orientationchange":"resize";

				if(document.addEventListener) {
					window.addEventListener(resizeEvt,this.recalc,false);
					document.addEventListener("DOMcontentLoaded",this.recalc,false);
					}
				else if(document.attachEvent) {
					document.attachEvent("on"+resizeEvt,this.recalc);
					document.attachEvent("on"+"DOMcontentLoaded",this.recalc);
				}
			},
			recalc() {
				this.setWidth(window.innerWidth)
			},
			...mapMutations({
				setWidth:'SET_WINDOW_WIDTH'
			})
		},
		components:{
			Tab,FooterBox
		}
	}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
 
</style>



// WEBPACK FOOTER //
// src/App.vue